"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var Button_1 = __importDefault(require("@mui/material/Button"));
var CircularProgress_1 = __importDefault(require("../CircularProgress/CircularProgress"));
var defaultProps_1 = __importDefault(require("./defaultProps"));
var makeButtonStyling_1 = __importDefault(require("./makeButtonStyling"));
var DynamicFontSizeContainer_1 = __importDefault(require("../DynamicFontSizeContainer/DynamicFontSizeContainer"));
var react_1 = require("@emotion/react");
var InsetCheckbox_1 = __importDefault(require("../InsetCheckbox/InsetCheckbox"));
var Button = function (_a) {
    var dataTestId = _a.dataTestId, disabled = _a.disabled, label = _a.label, loading = _a.loading, onClick = _a.onClick, selected = _a.selected, textOverflowHandling = _a.textOverflowHandling, Icon = _a.Icon, invertColors = _a.invertColors, experimentName = _a.experimentName, shouldPulse = _a.shouldPulse;
    var theme = (0, react_1.useTheme)();
    var startIcon = selected !== undefined ? ((0, jsx_runtime_1.jsx)(InsetCheckbox_1.default, { checked: selected, experimentName: experimentName })) : (Icon);
    return ((0, jsx_runtime_1.jsx)(Button_1.default, { fullWidth: true, css: (0, makeButtonStyling_1.default)(disabled, theme, textOverflowHandling, invertColors), disabled: disabled, startIcon: startIcon, endIcon: loading && (0, jsx_runtime_1.jsx)(CircularProgress_1.default, { experimentName: experimentName }), onClick: onClick, variant: 'contained', "data-testid": dataTestId, children: textOverflowHandling === 'dynamicFontSize' ? ((0, jsx_runtime_1.jsx)(DynamicFontSizeContainer_1.default, { text: label, possibleFontSizes: [
                theme.mvf.fontSize.little,
                theme.mvf.fontSize.mini,
                theme.mvf.fontSize.small,
                theme.mvf.fontSize.compact,
                theme.mvf.fontSize.medium,
                theme.mvf.fontSize.hefty,
                theme.mvf.fontSize.swoll,
                theme.mvf.fontSize.large,
            ], experimentName: experimentName })) : (label) }));
};
Button.defaultProps = defaultProps_1.default;
exports.default = Button;
//# sourceMappingURL=Button.js.map